/** 프로덕션 공개 사이트 origin (커스텀 도메인) */
export const PRODUCTION_SITE_ORIGIN = 'https://edukodi-classplanner.com';

/** Vercel 기본 배포 URL — 미리보기·과거 링크 호환용 */
export const LEGACY_VERCEL_SITE_ORIGIN = 'https://curriculum-planner-nine.vercel.app';
